import { CONTEXTUAL_HELP_URI } from '@/api/sirta/sirtaEndpoints';
import { computed, ref } from 'vue';
import type { ContextualHelpResponseData } from '@/types/contextualHelp.types';
import type { APIResponse } from '@/types';
import useAppFetch from '@/api/utils/useAppFetch';

export default function useGetContextualHelp() {
  const contextualHelpId = ref<string>();

  const fetchUri = computed<string>(() => `${CONTEXTUAL_HELP_URI}/${contextualHelpId.value}`);

  const appFetch = useAppFetch<ContextualHelpResponseData>(fetchUri, { immediate: false });
  const { execute, apiResponse, isFetching } = appFetch;
  appFetch.get().json();

  async function fetchHelp(helpId: string): Promise<APIResponse<ContextualHelpResponseData>> {
    contextualHelpId.value = helpId;
    await execute();
    return apiResponse;
  }

  return {
    isFetching,
    fetchHelp,
  };
}
